export default __webpack_public_path__ + "static/media/ATSAP_orange_v2.79702ee8.png";